import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["embedBoardKey", "metadataId", "image", "headline", "description", "wistiaVideoId", "onUseTemplateClick", "templateActions", "paidTemplateDescription"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import NextImage from 'next/legacy/image';
import styled, { useTheme } from 'styled-components';
import { Box, Button, getCookie, Heading, prefixUrl, Text, useWindowSize, Video } from '@miro-site/core';
import { useLocalization } from '@miro-site/localization';
import { useTreatment } from '@miro-site/splitio';
import BoardEmbedPreview from './BoardEmbedPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MediaContainer = styled(Box).withConfig({
  displayName: "PageHeader__MediaContainer",
  componentId: "sc-1bxw52l-0"
})(["border:1px solid var(--deprecated-template-preview-image-border-color);", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    borderRadius: 8,
    overflow: 'hidden',
    '& iframe': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      border: 'none'
    }
  });
});
var PageHeader = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var embedBoardKey = _ref2.embedBoardKey,
      metadataId = _ref2.metadataId,
      image = _ref2.image,
      headline = _ref2.headline,
      description = _ref2.description,
      wistiaVideoId = _ref2.wistiaVideoId,
      onUseTemplateClick = _ref2.onUseTemplateClick,
      templateActions = _ref2.templateActions,
      paidTemplateDescription = _ref2.paidTemplateDescription,
      props = _objectWithoutProperties(_ref2, _excluded);

  var theme = useTheme();

  var _useWindowSize = useWindowSize(),
      _useWindowSize$width = _useWindowSize.width,
      width = _useWindowSize$width === void 0 ? 0 : _useWindowSize$width;

  var isMobile = width < theme.breakpoints.small;

  var _useLocalization = useLocalization(),
      currentLocale = _useLocalization.currentLocale;

  var _useTreatment = useTreatment('WCORE-46_Website_Templates_Embed_AB', {
    locale: currentLocale,
    is_mobile: isMobile,
    is_desktop: !isMobile,
    is_bot: false,
    // I pass this as false since this check is implemented on SplitioProvider side
    prospect_user: !getCookie('ajs_user_id')
  }),
      _useTreatment2 = _slicedToArray(_useTreatment, 1),
      withEmbeds = _useTreatment2[0];

  var mediaContent = /*#__PURE__*/_jsx(NextImage, {
    src: prefixUrl(image.original.webp || ''),
    unoptimized: true,
    alt: image.name,
    priority: true,
    width: 1440,
    height: 960,
    layout: "responsive"
  });

  if (wistiaVideoId) {
    mediaContent = /*#__PURE__*/_jsx(Video, {
      id: wistiaVideoId
    });
  }

  if (withEmbeds === 'on') {
    mediaContent = /*#__PURE__*/_jsx(BoardEmbedPreview, {
      boardKey: embedBoardKey,
      imageSrc: prefixUrl(image.original.webp || ''),
      imageName: image.name
    });
  }

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    ref: ref,
    "data-track-place": "template-page-header",
    $pb: [20, 28, 28, 28],
    $styles: {
      display: [undefined, 'flex', 'flex', 'flex'],
      flexWrap: [undefined, 'nowrap', 'nowrap', 'nowrap'],
      flexDirection: [undefined, 'row-reverse', 'row-reverse', 'row-reverse']
    }
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(Box, {
      $mb: [40, null, null, null],
      $styles: {
        position: 'relative',
        borderRadius: 8,
        width: [325, 720, 720, 720],
        height: wistiaVideoId ? undefined : [216, 480, 480, 480]
      },
      children: /*#__PURE__*/_jsx(MediaContainer, {
        children: mediaContent
      })
    }), /*#__PURE__*/_jsxs(Box, {
      $styles: {
        textAlign: ['center', 'left', 'left', 'left'],
        width: ['100%', 400, 400, 400]
      },
      $mr: [null, 40, 40, 40],
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h1",
        $variant: "h2",
        $mb: [20, 24, 24, 24],
        children: headline
      }), /*#__PURE__*/_jsx(Text, {
        $variant: "p1",
        $mb: 40,
        $styles: {
          opacity: 'var(--wcds-legacy-paragraph-opacity)' // to be removed when VIS is the default theme

        },
        children: description
      }), /*#__PURE__*/_jsx(Button, {
        "data-track-id": "use-template",
        "data-template-id": metadataId,
        $buttonType: "primary",
        $size: "large",
        onClick: onUseTemplateClick,
        $mb: [12, 15],
        children: templateActions.USE_TEMPLATE
      }), paidTemplateDescription ? /*#__PURE__*/_jsx(Text, {
        $variant: "p2",
        $styles: {
          color: theme.templates.colors.secondary60
        },
        children: paidTemplateDescription
      }) : null]
    })]
  }));
});
PageHeader.displayName = 'PageHeader';
export default PageHeader;